export enum OperatorNodeType {
  Binary = 'binary',
  Unary = 'unary'
}

export enum ComputationNodeType {
  Operator,
  Operand
}

export enum ComputationBinaryOperators {
  Add,
  Subtract,
  Multiply,
  Divide,
  Exponent,
  Start_bracket,
  Close_bracket,
  Ceil,
  Floor,
  Abs
}

export enum ComputationNodeSubtype {
  Constant,
  Variable
}
